(function () {
  'use strict';

  angular.module('wsLrs.services').factory('BadgeRegistry', ['$http', '$q', 'Api', 'Resource', '$rootScope', function ($http, $q, Api, Resource, $rootScope) {
    $rootScope.$on('organization-selected', function () {
      registry.badges = {};
      registry._promise = null;
      registry._resource = new Resource("/badges/v2", false, true);
    });
    var registry = {
      badges: {},
      _promise: null,
      _resource: new Resource("/badges/v2", false, true),
      clear: function clear() {
        registry.badges = {};
      },
      add: function add(badge) {
        registry.badges[badge.id] = _.extend({
          id: badge.id
        }, badge.config);
      },
      get: function get(badgeId) {
        return registry.badges[badgeId];
      },
      has: function has(badgeId) {
        return registry.badges.hasOwnProperty(badgeId);
      },
      prepareBadges: function prepareBadges() {
        try {
          if (!registry._promise) {
            registry._promise = registry._resource.getAll({
              showHidden: true,
              ignoreReadPermissions: true
            }).then(function (badges) {
              return angular.forEach(badges, function (m) {
                return registry.add(m);
              });
            });
          }
          return registry._promise;
        } catch (e) {
          return $q.reject(e);
        }
      }
    };
    return registry;
  }]).factory('Badges', ['$http', '$q', 'Api', 'Resource', '$rootScope', function ($http, $q, Api, Resource, $rootScope) {
    $rootScope.$on('organization-selected', function () {
      res.def = null;
      res.getInProgress = false;
      res._resource = new Resource("/badges/v2", false, true);
    });
    var res = {
      def: null,
      getInProgress: false,
      _resource: new Resource("/badges/v2/search", false, true),
      list: function list() {
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
            countReports: false
          },
          _limit = _ref._limit,
          _offset = _ref._offset,
          searchText = _ref.searchText,
          order_by = _ref.order_by,
          countReports = _ref.countReports;
        // Don't cache, but prevent simultaneous fetches
        if (this.getInProgress) {
          return this.def.promise;
        }
        this.def = $q.defer();
        this.getInProgress = true;
        res._resource.list({
          countReports: countReports,
          showHidden: true,
          searchText: searchText,
          order_by: order_by,
          _limit: _limit,
          _offset: _offset
        }).then(function (badges) {
          res.def.resolve(badges);
          res.getInProgress = false;
        }, function () {
          res.def.resolve([]);
          res.getInProgress = false;
        });
        return this.def.promise;
      },
      getAll: function getAll() {
        var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
            countReports: false
          },
          countReports = _ref2.countReports;
        // Don't cache, but prevent simultaneous fetches
        if (this.getInProgress) {
          return this.def.promise;
        }
        this.def = $q.defer();
        this.getInProgress = true;
        res._resource.getAll({
          countReports: countReports,
          showHidden: true,
          order_by: "name",
          _limit: 1000
        }).then(function (badges) {
          res.def.resolve(badges);
          res.getInProgress = false;
        }, function () {
          res.def.resolve([]);
          res.getInProgress = false;
        });
        return this.def.promise;
      },
      get: function get(badgeId) {
        // Don't cache, but prevent simultaneous fetches
        if (this.getInProgress) {
          return this.def.promise;
        }
        this.def = $q.defer();
        this.getInProgress = true;
        res._resource.get(badgeId, {
          params: {
            returnReports: true,
            showHidden: true,
            "order_by": "name",
            _limit: 1000
          }
        }).then(function (badges) {
          res.def.resolve(badges);
          res.getInProgress = false;
        }, function () {
          res.def.resolve([]);
          res.getInProgress = false;
        });
        return this.def.promise;
      },
      getCommonBadges: function getCommonBadges() {
        var def = $q.defer();
        res.getAll().then(function (badges) {
          badges = _.map(badges, function (badge) {
            var b = angular.copy(badge.config);
            b.id = badge.id;
            b.credlyBadgeId = badge.credlyBadgeId;
            b.name = badge.name;
            b.dimension = badge.dimension;
            b.awardCount = badge.awardCount;
            b.badgeCategoryName = badge.badgeCategoryName;
            b.menuPosition = badge.menuPosition;
            return b;
          });
          def.resolve(badges);
        }, function () {
          def.resolve([]);
        });
        return def.promise;
      }
    };
    return res;
  }]);
})();
